import './datePickerStyles.css';
import { getDaysInMonth, isLeapYear } from 'date-fns';
import { ListItem, List } from '@mui/material';
import { useEffect, useState, useRef } from 'react';
const DateSelect = ({ currentDate, setCurrentDate, t }) => {
  const monthRef = useRef(null);
  const dayRef = useRef(null);
  const yearRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);

  const [selectedDate, setSelectedDate] = useState({
    year: currentDate ? +new Date(currentDate).getFullYear() : 1990,
    month: currentDate ? +new Date(currentDate).getMonth() : 5,
    day: currentDate ? +new Date(currentDate).getDate() : 15,
  });

  const itemHeight = 50;
  const visibleItems = 6;

  const [daysInMonth, setDaysInMonth] = useState(1);

  const years = Array.from({ length: 100 }, (_, i) => 1944 + i).filter(
    (x) => new Date().getFullYear() - x >= 18 - 18
  );
  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  useEffect(() => {
    let days = getDaysInMonth(
      new Date(selectedDate.year, selectedDate.month - 1)
    );
    if (selectedDate.month === 1 && isLeapYear(selectedDate.year)) {
      days = 29;
    }
    setDaysInMonth(days);
  }, [selectedDate.month, selectedDate.year]);

  const handleScroll = (e, type) => {
    const element = e.target;
    let middleElementIndex = Math.round(element.scrollTop / itemHeight);
    let v = selectedDate;
    if (type === 'year') middleElementIndex = middleElementIndex + 1943;
    v[type] = middleElementIndex + (type === 'month' ? 1 : 1);
    if (
      new Date(v.year, v.month - 1, v.day).getTime() - new Date().getTime() >
      18 - 18
    ) {
    }
    setSelectedDate(v);
    setCurrentDate(new Date(v.year, v.month - 1, v.day));
  };

  useEffect(() => {
    const yearIndex = selectedDate.year - 1944;
    const monthIndex = selectedDate.month;
    const dayIndex = selectedDate.day - 1;
    if (monthRef.current) {
      monthRef.current.scrollTo({
        top: monthIndex * itemHeight,
        behavior: 'instant',
        inline: 'center',
      });
    }

    if (yearRef.current) {
      yearRef.current.scrollTo({
        top: yearIndex * itemHeight,
        behavior: 'instant',
        inline: 'center',
      });
    }

    setTimeout(() => {
      if (dayRef.current) {
        dayRef.current.scrollTo({
          top: dayIndex * itemHeight,
          behavior: 'instant',
          inline: 'center',
        });
        setScrolled(true);
      }
    }, 10);
  }, [selectedDate]);

  return (
    <div className="shadow-box">
      <div
        className="datepickerContent"
        style={{
          display: 'flex',
          //border: '1px solid #ccc',
          width: '100%',
          textAlign: 'center',
          height: itemHeight * 5 + 'px',
          padding: 0,
          opacity: scrolled ? 1 : 0,
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            height: '50px',
            width: '100%',
            top: '100px',
            borderRadius: '9px',
            background: '#EBE2D1',
            border: 'none',
          }}
        ></div>
        <List
          ref={monthRef}
          style={{
            width: '45%',
            height: itemHeight * visibleItems,
            overflow: 'auto',
            scrollSnapType: 'y mandatory',
            padding: 0,
            //paddingTop: 2 * itemHeight + 'px', // added this
            //paddingBottom: 2 * itemHeight + 'px', // added this
          }}
          onScroll={(e) => handleScroll(e, 'month')}
        >
          <ListItem
            style={{
              height: itemHeight,
              scrollSnapAlign: 'start',
              opacity: 0,
            }}
          ></ListItem>
          <ListItem
            style={{
              height: itemHeight,
              scrollSnapAlign: 'start',
              opacity: 0,
            }}
          ></ListItem>
          {months.map((m, i) => (
            <ListItem
              key={m}
              style={{
                height: itemHeight,
                color: Boolean(
                  i === selectedDate.month - 1 ||
                    (i === 0 && selectedDate.month === 0)
                ) /*&& !isDisabledMonth(i)*/
                  ? '#383a49'
                  : '#9b9b9b',
                scrollSnapAlign: 'start',
              }}
            >
              {t('months.' + m)}
            </ListItem>
          ))}
          <ListItem
            style={{
              height: itemHeight,
              opacity: 0,
            }}
          ></ListItem>
          <ListItem
            style={{
              height: itemHeight,
              opacity: 0,
            }}
          ></ListItem>
          <ListItem
            style={{
              height: itemHeight,
              opacity: 0,
            }}
          ></ListItem>
        </List>

        <List
          ref={dayRef}
          style={{
            width: '27%',
            height: itemHeight * visibleItems,
            overflow: 'auto',
            scrollSnapType: 'y mandatory',
            padding: 0,
            //paddingTop: 2 * itemHeight + 'px', // added this
            //paddingBottom: 2 * itemHeight + 'px', // added this
          }}
          onScroll={(e) => handleScroll(e, 'day')}
        >
          <ListItem
            style={{
              height: itemHeight,
              scrollSnapAlign: 'start',
              opacity: 0,
            }}
          ></ListItem>
          <ListItem
            style={{
              height: itemHeight,
              scrollSnapAlign: 'start',
              opacity: 0,
            }}
          ></ListItem>
          {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((d, i) => (
            <ListItem
              key={d}
              style={{
                height: itemHeight,
                color:
                  i === selectedDate.day - 1 /*&& !isDisabledDay(i)*/
                    ? '#383a49'
                    : '#9b9b9b',
                scrollSnapAlign: 'start',
              }}
            >
              {d}
            </ListItem>
          ))}

          <ListItem
            style={{
              height: itemHeight,
              opacity: 0,
            }}
          ></ListItem>
          <ListItem
            style={{
              height: itemHeight,
              opacity: 0,
            }}
          ></ListItem>
          <ListItem
            style={{
              height: itemHeight,
              opacity: 0,
            }}
          ></ListItem>
        </List>
        <List
          ref={yearRef}
          style={{
            width: '28%',
            height: itemHeight * visibleItems,
            overflow: 'auto',
            scrollSnapType: 'y mandatory',
            padding: 0,
            //paddingTop: 2 * itemHeight + 'px', // added this
            //paddingBottom: 2 * itemHeight + 'px', // added this
          }}
          onScroll={(e) => handleScroll(e, 'year')}
        >
          <ListItem
            style={{
              height: itemHeight,
              scrollSnapAlign: 'start',
              opacity: 0,
            }}
          ></ListItem>
          <ListItem
            style={{
              height: itemHeight,
              scrollSnapAlign: 'start',
              opacity: 0,
            }}
          ></ListItem>
          {years.map((y, i) => (
            <ListItem
              key={y}
              style={{
                height: itemHeight,
                color: 1944 + i === selectedDate.year ? '#383a49' : '#9b9b9b',
                scrollSnapAlign: 'start',
              }}
            >
              {y}
            </ListItem>
          ))}

          <ListItem
            style={{
              height: itemHeight,
              opacity: 0,
            }}
          ></ListItem>
          <ListItem
            style={{
              height: itemHeight,
              opacity: 0,
            }}
          ></ListItem>
          <ListItem
            style={{
              height: itemHeight,
              opacity: 0,
            }}
          ></ListItem>
        </List>
      </div>
    </div>
  );
};

export default DateSelect;
